import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const useQuantitySelectionControls = ({
  currentVariant,
}: {
  currentVariant: PimProductV11
}): {
  quantity: number
  setQuantity: Dispatch<SetStateAction<number>>
} => {
  const [quantity, setQuantity] = useState(1)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- don't reference, refactor if touched
    setQuantity(1)
  }, [currentVariant.upid])

  return {
    quantity,
    setQuantity,
  }
}
